import React, { useState } from 'react';

function CheckBoxComp(props) {
  var [isChecked, setIsChecked] = useState(props.isChecked);
  
  const title = props.title;
  const value = props.value;
  const item = props.item;
  let image;
  let checkbox;
  if (item != null) {
    image = <img src={props.item}  width={80} />;
  }
  
  if (isChecked ) {
    checkbox = (
      <div className={'flex flex-row'}>
        <input
          type='checkbox'
          id='opsi'
          name='topping'
          value={value}
          checked
          onChange={props.onChange
          }
          />{' '}
        <p className='m-auto pl-2'>{title}</p>
      </div>
    );
  } else {
    checkbox = (
      <div className={'flex flex-row'}>
        <input
          type='checkbox'
          id='opsi'
          name='topping'
          value={value}
          onChange={props.onChange
            }
          />{' '}
        <p className='m-auto pl-2'>{title}</p>
      </div>
    );
  }

  return (
    <div className={'container flex flex-row gap-2 p-3'}>
      <div className={'p-2'}></div>
      {image}
      {checkbox}
    </div>
  );
}

export default CheckBoxComp;
